// extracted by mini-css-extract-plugin
export var emptyState = "_54-d";
export var statCard = "_54-c";
export var table = "_54-0";
export var tableCell = "_54-4";
export var tableCellClickable = "_54-5 _54-4";
export var tableCellDefault = "_54-6 _54-4";
export var tableCellEmpty = "_54-8";
export var tableCellWithValue = "_54-7";
export var tableContainer = "_54-e";
export var tableHeaderWeight = "_54-1";
export var tableHeaderZone = "_54-2";
export var tableRowHeader = "_54-3";
export var viewModeButton = "_54-9";
export var viewModeButtonActive = "_54-a _54-9";
export var viewModeButtonInactive = "_54-b _54-9";